const wineList = [
  {
    type: "Red",
    list: [
      {
        name: "Hangtime 2014",
        type: "Pinot Noir",
        location: "California",
        glass: "$7.50",
        bottle: "$28.00",
        description:
          "Notes of vanilla with intense black cherry aromas and flavors",
      },
      {
        name: "Alamos 2015",
        type: "Malbec",
        location: "Mendoza",
        glass: "$5.50",
        bottle: "$20.00",
        description:
          "Blackberries and blueberries, hints of mocha and spice, full bodied with good acidity",
      },
      {
        name: "Storypoint 2014",
        type: "Cabernet Sauvignon",
        location: "California",
        glass: "$7.00",
        bottle: "$26.00",
        description:
          "Rich and intense, this highly aromatic Cabernet Sauvignon features subtle spice characters and layers of dark fruit flavors and toffee notes",
      },
    ],
  },
  {
    type: "White",
    list: [
      {
        name: "Gabbiano",
        type: "Pinot Grigio",
        location: "Italy",
        glass: "$5.50",
        bottle: "$20.00",
        description:
          "Delicate and fruity with elegant floral notes...refined balance between sweetness and acidity",
      },
      {
        name: "Mobilo 2015",
        type: "Sauvignon Blanc",
        location: "New Zealand",
        glass: "$6.50",
        bottle: "$24.00",
        description:
          "Fresh and crisp, with zesty flavors of ripe passionfruit and pineapple",
      },
      {
        name: "Canyon Road 2015",
        type: "Chardonnay",
        location: "California",
        glass: "$5.50",
        bottle: "$20.00",
        description:
          "Creamy and rich yet refreshing, giving way to notes of vanilla, Meyer lemon, and tropical fruit",
      },
      {
        name: "Promessa 2015",
        type: "",
        location: "",
        glass: "$4.00",
        bottle: "",
        description: "",
      },
    ],
  },
];

export default wineList;



// WEBPACK FOOTER //
// ./src/services/drinkLists/wineList.js